<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M11.5 0.34375C11.9315 0.34375 12.2812 0.693528 12.2812 1.125V1.91214C14.4358 1.94464 16.5581 2.11136 18.6402 2.40439C19.7092 2.55484 20.7675 2.73857 21.8142 2.95453C22.2066 3.03551 22.4742 3.40033 22.4335 3.799C22.3928 4.19768 22.057 4.50091 21.6563 4.50091H19.6587L22.2354 15.0473C22.32 15.3936 22.1594 15.7533 21.8451 15.9215C20.857 16.4504 19.728 16.75 18.5313 16.75C17.3346 16.75 16.2056 16.4504 15.2174 15.9215C14.9031 15.7533 14.7426 15.3936 14.8272 15.0473L17.4039 4.50091H12.2812V18.3351C13.6276 18.4133 14.9212 18.6922 16.1319 19.1428C16.4862 19.2747 16.6953 19.6413 16.6283 20.0134C16.5613 20.3855 16.2374 20.6562 15.8594 20.6562H7.14026C6.76219 20.6562 6.43837 20.3855 6.37137 20.0134C6.30438 19.6413 6.51343 19.2747 6.86776 19.1428C8.07857 18.6922 9.37229 18.4133 10.7188 18.3351V4.50091H5.59623L8.1729 15.0473C8.25751 15.3936 8.09695 15.7533 7.78264 15.9215C6.79449 16.4504 5.66547 16.75 4.4688 16.75C3.27212 16.75 2.1431 16.4504 1.15495 15.9215C0.840641 15.7533 0.680084 15.3936 0.764694 15.0473L3.34136 4.50091H1.3438C0.943046 4.50091 0.607286 4.19768 0.566585 3.799C0.525884 3.40033 0.793442 3.03551 1.18592 2.95453C2.23255 2.73857 3.29091 2.55484 4.35992 2.40439C6.44197 2.11137 8.56427 1.94465 10.7188 1.91214V1.125C10.7188 0.693528 11.0685 0.34375 11.5 0.34375ZM16.5812 14.4515L18.5313 6.46975L20.4814 14.4515H16.5812ZM6.41887 14.4515L4.4688 6.46975L2.51872 14.4515H6.41887Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgScale',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>